<template>
	<div class="page" ref="page">

		<div :style="{ padding: '8px 16px' }" class="content">
			<div v-for="(item, index) in logs" :key="index" class="lineItem lineHead">
				<div class="date">{{ parseTime(item.time) }}</div>
				<div class="axis">
					<div class="circle first" :class="[index === 0?'cur':'']"></div>
					<div class="line"></div>
				</div>
				<div class="content">
					<div class="version">{{ item.versionName }}</div>
					<div class="description" v-html="item.log.replace(/\n/g,'<br/>')"></div>
				</div>
			</div>
		</div>
		<Spin size="large" fix v-if="spinShow"></Spin>
	</div>
</template>

<script>
	import {logList} from "@/net/service/updateLogService";
	import Spin from "view-design/src/components/spin";

	export default {
		components: {
			Spin
		},
	data() {
		return {
			spinShow: true,
			logs: [
                {
                    time: '2020.4.6',
                    versionName: 'v0.0.2',
                    log: `1、A 书籍网格视图增加书籍名称
                    2、U 章节列表名称限制为最多显示两行
                    3、F 修复编辑器标题栏无法点击快捷符号栏进行输入的问题
                    4、U 限制编辑器标题栏不能换行
                    5、F 解决了几个小bug
                    6、U 优化展开型列表创建章节时选中的默认分卷（为上次展开的分卷或最后一个展开的分卷）
                   `
                }
			],
			pageConfig: {
				pageSize: 20,
				pageNum: 1
			}
		};
	},
	created(){
		logList({
			pageSize: this.pageConfig.pageSize,
			pageNum: this.pageConfig.pageNum
		}).then(res=>{
			this.logs = res.data.data.list
		}).finally(()=>{
			this.spinShow = false
		})
	},
	methods: {
		parseTime(datetime){
			let date = new Date(datetime);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
			let year = date.getFullYear(),
					month = ("0" + (date.getMonth() + 1)).slice(-2),
					sdate = ("0" + date.getDate()).slice(-2);
			// 拼接
			return year + "." + month + "." + sdate;
		},
		onApplyClick() {
			console.log('点击提交');
		}
	}
};
</script>

<style lang="less" scoped>
	@import "../../styles/index";

  .page {
    padding-top: 16px;
  }
	.title{
		color: @color-main-text;
		text-align: center;
		font-weight: bold;
		font-size: 16px;
	}
	.content{
		background: #FFFFFF;
	}

	.lineItem {
		display: flex;
		.date {
			width: 85px;
		}

		.axis {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			margin: 0 12px;

			.circle {
				width: 14px;
				height: 14px;
				border-radius: 50%;
				background: @primary-color
			}
			.cur{
				box-shadow: 0 0 0 5px @primary-color-light;
			}
			.line {
				flex: 1;
				width: 1px;
				background: @primary-color;
			}
		}

		.content {
			font-size: 16px;
			flex: 1;
			padding-bottom: 20px;

			.description {
				margin-top: 12px;
				color: @color-sub-text;
			}
		}
	}
</style>
